import { render, staticRenderFns } from "./ExportSalesByProduct.vue?vue&type=template&id=4b5bab19&"
import script from "./ExportSalesByProduct.vue?vue&type=script&lang=js&"
export * from "./ExportSalesByProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports